module.exports = __webpack_public_path__ + "static/media/20e-01-HOME_ST-2020-188x135cm-oleo-sobre-tela.698a1749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20e/20e-01-HOME_ST-2020-188x135cm-oleo-sobre-tela.jpg
// module id = 254
// module chunks = 0